export default __webpack_public_path__ + "static/media/signIn-bg.3a7fa10b.webp";